import moment from 'moment';

export const get_lat_lng = address => {
	return fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${address.address1},+${address.city},+${address.state}&key=AIzaSyC7dego6EaAb6xOYyxugb3O16PWMLHii8k&`)
	.then(response => {
		return response.json();
	}).then(location => {
		return location.results[0].geometry.location;
	})
};

export const get_delivery_offset = (deliveryDate, deliveryOffsets) => {
	if (!deliveryDate) {
		return null;
	}
	let start = moment(deliveryDate);
	const week = start.week();
	if (start.weekday() < 3) {
		// check A
		let offset = deliveryOffsets[`${week}A`];
		if (offset) {
			return start.subtract(offset);
		}
	} else {
		// check B
		let offset = deliveryOffsets[`${week}B`];
		if (offset) {
			return start.subtract(offset);
		}
	}
	return null;
};

export const get_next_order_cutoff_datetime = (cutoffs, deliveryOffsets, pickupDay, isAdmin) => {
	let nowCutoff = moment.utc();
	if (!cutoffs || cutoffs.length === 0) {
		nowCutoff.add(7, 'd');
	} else {
		let cutoffKey = `orderCutoff${pickupDay === 1 ? 'Monday' : 'Thursday'}${isAdmin ? 'Admin' : 'Customer'}`;
		if (!cutoffs[cutoffKey]) {
			nowCutoff.add(7, 'd');
		} else {
			let cutoffDelta = cutoffs[cutoffKey];
			nowCutoff.add(cutoffDelta);
		}
	}

	let nextPD = moment.utc().day(pickupDay).startOf('day');
	let keepGoing = true
	while (keepGoing) {
		// nextPD.isBefore(nowCutoff)
		// check delivery offset for this week+pickupday
		// if NPD - DO > now+cutoff, G2G
		let doCheck = moment(nextPD);
		let week = nextPD.week();
		if (pickupDay < 3) {
			// check A
			let offset = deliveryOffsets[`${week}A`];
			if (offset) {
				doCheck.subtract(offset);
			}
		} else {
			// check B
			let offset = deliveryOffsets[`${week}B`];
			if (offset) {
				doCheck.subtract(offset);
			}
		}
		if (nowCutoff.isBefore(doCheck)) {
			keepGoing = false
			break
		}
		nextPD.add(7, 'd');
	}
	return nextPD.toDate();
};

export const get_order_cutoff_datetime = (cutoffs, deliveryOffsets, deliveryDate, customize, isAdmin, flex = false) => {
	let stripped = moment(deliveryDate).format('YYYY-MM-DD');
	let delivery = moment.utc(stripped).startOf('day');
	const pickupDay = delivery.weekday();
	const week = delivery.week();
	// Check for offsets
	if (deliveryOffsets) {
		if (pickupDay < 3) {
			// check A
			let offset = deliveryOffsets[`${week}A`];
			if (offset) {
				delivery.subtract(offset);
			}
		} else {
			// check B
			let offset = deliveryOffsets[`${week}B`];
			if (offset) {
				delivery.subtract(offset);
			}
		}
	}
	let defaultDelta = customize ? 6 : pickupDay === 4 ? 2 : 3;
	if (!cutoffs || cutoffs.length === 0) {
		return delivery.subtract(defaultDelta, 'days').toDate();
	}
	let cutoffKey = `${customize ? 'customize' : flex ? 'flex' : 'order'}Cutoff${pickupDay === 4 ? 'Thursday' : 'Monday'}${isAdmin ? 'Admin' : 'Customer'}`;
	if (!cutoffs[cutoffKey]) {
		return delivery.subtract(defaultDelta, 'days').toDate();
	}
	let cutoffDelta = cutoffs[cutoffKey];
	return delivery.subtract(cutoffDelta).toDate();
};

export const is_order_item_before_cutoff = (cutoffs, deliveryOffsets, orderItem, isAdmin) => {
	let hasSubs = orderItem.substitutions && orderItem.substitutions.length > 0;
	return moment().isBefore(get_order_cutoff_datetime(cutoffs, deliveryOffsets, orderItem.deliveryDate, hasSubs, isAdmin));
};

export const get_meal_week = (deliveryDate) => {
	let dd = moment(deliveryDate);
	const ref = moment('2017-12-31');
	dd.day(0);
	dd.set({
		'h': 5,
		'm': 0,
		's': 0
	});
	let dur = moment.duration(dd.diff(ref));
	let delta = Math.floor(dur.asWeeks());
	return ((delta + 1) % 5) + 1;
};

// This is a cool method to reduce an array to unique values based on a selector you pass in
Array.prototype.unique = function (selector) {
	return this.filter((e, i) => this.findIndex((a) => {
		if (selector) {
			return selector(a) === selector(e);
		}
		return a === e;
	}) === i);
};

export const format_phone = (number) => {
	return number ? number.replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '';
};

export const user_has_phone = (user) => {
	return user_primary_phone(user) !== null;
};

export const user_primary_phone = (user) => {
	if (user && user.phoneHome && user.phoneHome.length >= 10) {
		return user.phoneHome;
	}
	if (user && user.phoneCell && user.phoneCell.length >= 10) {
		return user.phoneCell;
	}
	if (user && user.phoneWork && user.phoneWork.length >= 10) {
		return user.phoneWork;
	}
	return null;
};

export default {
	get_lat_lng,
	get_delivery_offset,
	get_order_cutoff_datetime,
	get_meal_week,
	format_phone,
	user_has_phone,
	user_primary_phone
};

